module.exports = require("react-slider");